import React, { Fragment } from "react";

import { AppContext } from '../../contexts/AppContext';

import '../../../css/shared/component-fader.scss';
export class ComponentFader extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);

    this.componentRef = React.createRef();
  }

  componentDidMount() {
    const { verticalScrollObserve } = this.context;

    verticalScrollObserve(this.componentRef.current);
  }

  render() {
    return (
      <div className="component-fader" ref={this.componentRef}>
        {this.props.children}
      </div>
    );
  }
}